import { useCallback } from 'react';
import { useModalV2 } from 'common/modal/hooks/useModalV2';
import { getSourcingInternalSelectedCandidateProfileColumns } from 'modules/sourcing-internal/tables/columns';
import { SourcingInternalSelectedCandidateProfileTableData } from 'modules/sourcing-internal/tables/types/SourcingInternalSelectedCandidateProfileTableData';
import { TableV3ColDefs } from 'common/table';

type UseSourcingInternalSelectedCandidateProfileTableColumnsProps = {
  onRemoveSelectedCandidate: (selectionId: string) => Promise<void>;
  refetch: () => void;
};

export const useSourcingInternalSelectedCandidateProfileTableColumns = ({
  onRemoveSelectedCandidate,
  refetch
}: UseSourcingInternalSelectedCandidateProfileTableColumnsProps): TableV3ColDefs<
  SourcingInternalSelectedCandidateProfileTableData,
  never
> => {
  const { openModal } = useModalV2();

  const handleRemove = useCallback(
    (row: SourcingInternalSelectedCandidateProfileTableData) => {
      const handleConfirm = async () => {
        await onRemoveSelectedCandidate(row.selectionId);
        refetch();
      };

      openModal({
        title: 'Remove candidate?',
        subtitle: 'This cannot be undone.',
        primaryButtonText: 'No',
        secondaryButtonText: 'Yes',
        secondaryButtonProps: {
          variant: 'tertiary',
          state: 'destructive'
        },
        onSecondaryAction: handleConfirm
      });
    },
    [openModal, onRemoveSelectedCandidate, refetch]
  );

  return getSourcingInternalSelectedCandidateProfileColumns({ handleRemove });
};
